import { workspaceTypeOrder } from '@platform/navigation';

/** Типи просторів прототипу v4 (WS_TYPES): їхні групи й чипи показуються завжди, навіть порожні. */
export const prototypeWorkspaceTypes: readonly string[] = ['mp', 'group', 'committee', 'party'];

/**
 * Група простору в перемикачі й навігаторі просторів (прототип v4 wsType): парламент прототип зберігає як комітет (rw.type 'committee'),
 * тож він — серед «Комітетів»; невідомий тип — серед офісів депутатів. Чиста функція.
 */
export function workspaceGroup(type: string): string {
  if (type === 'parliament') return 'committee';
  return workspaceTypeOrder().includes(type) ? type : 'mp';
}
